'use es6';

import { parse, stringify } from 'hub-http/helpers/params';
import omit from 'transmute/omit';
export const getQueryParamsObject = history => {
  const {
    location: {
      search
    }
  } = history || window;
  return parse(search.replace(/^\?/, ''));
};
export const removeQueryParams = keys => {
  const queryParamsObject = getQueryParamsObject();
  const newQueryMap = omit(keys, queryParamsObject);
  return stringify(newQueryMap);
};